import { render, staticRenderFns } from "./staff-list.vue?vue&type=template&id=063d899a&scoped=true"
import script from "./staff-list.vue?vue&type=script&lang=js"
export * from "./staff-list.vue?vue&type=script&lang=js"
import style0 from "./staff-list.vue?vue&type=style&index=0&id=063d899a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d899a",
  null
  
)

export default component.exports